<div class="container" class="py-2" (window:resize)="OnResize()">
  <footer *ngIf="!smallScreen" style="text-align: center;">
    <a style="color: #00afef; cursor: pointer;" target="_blank" (click)="legal_OnClick()">Privacy & Legal</a>
  </footer>
</div>

<div *ngIf="modal.config">
  <app-modal [modalConfig]="modal.config" (selected)="modal.OnSelected($event);"></app-modal>
</div>